import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ManagerIcon: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props}>
      <path d='M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19ZM11 10V17H13V10H11Z' />
    </SvgIcon>
  );
};
